import angular from 'angular';

import ApiModule from './api/api.module';
import AppLaunch from './app-launch/app-launch.component';
import AuthorizationModule from './authorization/authorization.component';
import Bodycodes from './bodycodes/bodycodes.component';
import ForcePasswordChange from './force-password-change/force-change.component';
import Frontpage from './frontpage/frontpage.component';
import FuelReceipts from './fuel-receipts/fuel.component';
import PageNotFound from './page-not-found/page-not-found.component';
import ReactivateVehicle from './reactivate-vehicle/reactivation.component';
import Settings from './settings/settings.component';
import Survey from './survey/survey.component';
import TenantComponent from './tenant/tenant.component';
import TradeIns from './trade-ins/trade-ins.component';
import UserManagement from './user-management/user.component';
import UserSettings from './user-settings/user-settings.component';
import VehicleDetail from './vehicle-detail/vehicle-detail.component';
import VehicleImportIntro from './vehicle-import-intro/import-intro.component';
import Workflows from './workflows/workflows.component';

const DEPENDENCIES = [
  AppLaunch,
  AuthorizationModule,
  ApiModule,
  Bodycodes,
  ForcePasswordChange,
  Frontpage,
  FuelReceipts,
  PageNotFound,
  ReactivateVehicle,
  Settings,
  Survey,
  TenantComponent,
  TradeIns,
  UserManagement,
  UserSettings,
  VehicleDetail,
  VehicleImportIntro,
  Workflows,
];

export default angular.module('autoboard.components', DEPENDENCIES)
  .name;
